
import { Injectable } from '@angular/core';
import { HttpHelperService } from './http-helper.service';


import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private baseUrl = environment.endpoint + '/core';

  constructor(
    private httpHelperService: HttpHelperService,
  ) {
  }

  async getStats() {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}/stats`
      );
      if (result && result.response) {
        resolve(result.response);

      } else {
        reject('API ERROR');
      }
    });
  }
  async getDocumentsStats() {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}/documents-stats`
      );
      if (result && result.response) {
        resolve(result.response);

      } else {
        reject('API ERROR');
      }
    });
  }

  async getRelevantKeysStats() {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}/relevant-keys-stats`
      );
      if (result && result.response) {
        resolve(result.response);

      } else {
        reject('API ERROR');
      }
    });
  }


  async getFeed(nextToken: any, docType: any) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/feed`,
        { nextToken, docType }
      );
      if (result && result.response && result.response) {
        if (result.response.items) {
          resolve(result.response);
        } else {
          resolve([]);
        }
      } else {
        reject('API ERROR');
      }
    });
  }

  async search(searchTerm: any, cancelSignal?: Subject<void>) {
    return new Promise<any>(async (resolve, reject) => {
      const result: any = await this.httpHelperService.requestPromise(
        'POST',
        `${this.baseUrl}/search`,
        { searchTerm },
        undefined,
        cancelSignal
      ).catch((error) => {
        console.error(error);
        reject("An Error Occur!, Try again later.");
      });

      if (result && result.response) {

        resolve(result.response);

      } else {
        reject("An Error Occur!, Try again later.");
      }
    });
  }
}
